import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IReduxState } from 'src/store';
import { IReducerBoardState } from 'src/store/board/types';
import { Notification } from 'src/utils';
import { ITask } from 'src/interfaces/task';
import { ICard } from 'src/interfaces/board';
import { ITechnician } from 'src/interfaces/technician';

import { IProps } from './board-technicians.type';

const useBoard = (props: IProps) => {
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [spinning, setSpinning] = useState(false);

  const [tasks, setTasks] = useState<ITask[] | undefined>(undefined);
  const dispatch = useDispatch();
  const listsById = useSelector((state: IReduxState) => state.board.listsById);
  const cardsById = useSelector((state: IReduxState) => state.board.cardsById);
  const filter = useSelector((state: IReduxState) => state.tasks.filter);
  const technicians = useSelector(
    (state: IReduxState) => state.technicians.all
  );

  const handleTasks = async () => {
    setLoading(true);

    if (technicians?.length) {
      let lists = ['0'];

      technicians.forEach((item: ITechnician) => {
        lists.push(String(item.id));
      });

      const listsById: any = [
        {
          _id: '0',
          title: 'PENDENTES',
          cards: [],
        },
      ];

      technicians.forEach((item: ITechnician) => {
        listsById[item.id] = {
          _id: String(item.id),
          title: item.name,
          cards: [],
        };
      });

      const initialState: IReducerBoardState = {
        lists,
        listsById,
        cardsById: [],
      };

      dispatch({
        type: 'CHANGE_BOARD_TYPE',
        payload: initialState,
      });
    }

    try {
      const response: ITask[] | undefined = await props.fetchTasks(filter);

      if (response) {
        setTasks(response);
        boardSeeder(response);
      }
    } catch (err: any) {
      Notification.error({
        message:
          'Ocorreu um erro ao carregar as tarefas, tente novamente mais tarde.',
      });

      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleTechnicians = async () => {
    try {
      const response = await props.fetchTechnicians();

      if (response) {
        return true;
      }
    } catch (err: any) {
      Notification.error({
        message:
          'Ocorreu um erro ao carregar os operadores técnicos, tente novamente mais tarde.',
      });

      return false;
    }
  };

  const boardSeeder = async (data: ITask[]) => {
    for await (const item of data) {
      const { technicianTasks } = item;

      if (technicianTasks?.length) {
        for await (const technicianTask of technicianTasks) {
          let card = {
            listId: String(technicianTask?.technicianId),
            listText: String(technicianTask?.technician?.name),
            cardId: String(item.id),
            cardText: `#${item.id}`,
            ...item,
          };

          dispatch({
            type: 'ADD_LIST_CARD',
            payload: card,
          });

          dispatch({
            type: 'ADD_CARD',
            payload: card,
          });
        }
      } else {
        let card = {
          listId: '0',
          listText: 'PENDENTES',
          cardId: String(item.id),
          cardText: `#${item.id}`,
          ...item,
        };

        dispatch({
          type: 'ADD_LIST_CARD',
          payload: card,
        });

        dispatch({
          type: 'ADD_CARD',
          payload: card,
        });
      }
    }
  };

  const updateTechniciansTask = async (taskId: string, tecnicianId: string) => {
    let technicians: [{ id: number; principal: boolean }] | any = [];

    technicians.push({
      id: Number(tecnicianId),
      principal: true,
    });

    try {
      await props.updateTask(taskId, { technicians });
    } catch (err: any) {
      Notification.error({
        message:
          'Ocorreu um erro ao carregar as tarefas, tente novamente mais tarde.',
      });

      return false;
    }
  };

  const handleDragEnd = ({ source, destination }: any) => {
    if (!destination) return;

    console.log(destination);

    if (destination.droppableId === '0')
      return Notification.error({
        message: 'Essa ação não é permitida neste modo.',
      });

    if (
      source.index !== destination.index ||
      source.droppableId !== destination.droppableId
    ) {
      let taskId: any = Array.from(listsById[source.droppableId].cards).splice(
        source.index,
        1
      )[0];

      let card: ICard = cardsById[taskId];

      if (card.stage === 2)
        return Notification.error({
          message:
            'Ação não permitida, essa ordem de serviço já foi finalizada.',
        });

      if (
        !!card.technicianTasks.filter(
          (item: any) => item.id === destination.index
        ).length
      )
        return Notification.error({
          message:
            'Ação não permitida, esse técnico já está trabalhando nessa ordem de serviço.',
        });

      updateTechniciansTask(taskId, destination.droppableId);

      dispatch({
        type: 'MOVE_LIST_CARD',
        payload: {
          sourceListId: source.droppableId,
          destListId: destination.droppableId,
          oldCardIndex: source.index,
          newCardIndex: destination.index,
        },
      });
    }
  };

  const handleReload = () => {
    setReload(!reload);
  };

  return {
    handleTasks,
    handleTechnicians,
    loading,
    tasks,
    handleDragEnd,
    reload,
    handleReload,
    spinning,
    setSpinning,
    filter,
  };
};

export default useBoard;
